module.exports = __webpack_public_path__ + "img/angle_180.c4d6df09.jpg";